import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DarkModeState {
	isDark: boolean;
	setIsDark: (newValue: boolean) => void;
	toggleIsDark: () => void;
}

const useDarkmode = create<DarkModeState>()(
	persist(
		(set, get) => ({
			isDark: false,
			setIsDark: (newValue) => {
				if (newValue) {
					updateDocument(newValue);
				} else {
					updateDocument(newValue);
				}
				set({ isDark: newValue });
			},
			toggleIsDark: () => {
				const current = get().isDark;
				updateDocument(!current);
				set({ isDark: !current });
			},
		}),
		{
			name: "darkmode-store",
			onRehydrateStorage: () => (state) => {
				if (state?.isDark) {
					updateDocument(true);
				} else {
					updateDocument(false);
				}
			},
		}
	)
);

function updateDocument(newValue: boolean) {
	if (newValue) {
		document.body.classList.add("dark");
		document.querySelector("html")?.classList.add("bg-[#121212]");
		document
			.querySelector('meta[name="theme-color"]')
			?.setAttribute("content", "#121212");
	} else {
		document.body.classList.remove("dark");
		document.querySelector("html")?.classList.remove("bg-[#121212]");
		document
			.querySelector('meta[name="theme-color"]')
			?.setAttribute("content", "#121212");
	}
}

export default useDarkmode;
